import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { ModalRadialProgression } from '@/features/jobs/scoping/components/ModalRadialProgression'

export interface OCRBulkProgressDialogProps {
  showing: boolean
  progress: number
  completedCount: number
  selectedCount: number
  isProcessing: boolean
  hasErrors: boolean
  cancelled: boolean
  completedSuccessfullyCount: number
  errorCount: number
  onCancel: () => unknown
  onClose: () => unknown
}

export function OCRBulkProgressDialog({
  showing,
  progress,
  completedCount,
  selectedCount,
  isProcessing,
  hasErrors,
  cancelled,
  completedSuccessfullyCount,
  errorCount,
  onCancel,
  onClose,
}: OCRBulkProgressDialogProps) {
  const hasFinishedWithErrors = !isProcessing && hasErrors
  return (
    <ModalSheet showing={showing} disableCloseOnOutsideClick>
      <ModalSheetHeader />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalRadialProgression
            progress={progress}
            completed={completedCount}
            total={selectedCount}
            withError={hasFinishedWithErrors}
          />
        </ModalSheetContentBlock>
        {isProcessing ? (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The jobs are being processed
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              If you close this window, the remaining jobs will not get
              processed.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        ) : hasErrors ? (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The process has {cancelled ? 'been cancelled and ' : ''}
              finished with errors
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              A total of {completedSuccessfullyCount} jobs were successfully
              processed, and {errorCount} failed with errors.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        ) : (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The process has
              {cancelled ? ' been cancelled' : ' finished processing'}
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              A total of {completedSuccessfullyCount} jobs were successfully
              processed.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        )}
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          {isProcessing ? (
            <Button label="Cancel" onPress={onCancel} />
          ) : (
            <Button label="Close" onPress={onClose} />
          )}
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
